module.exports = __webpack_public_path__ + "img/drink4.82db4565.png";